<ion-tabs
  [class.tab-transition]="isTransition()"
  (ionTabsWillChange)="onTabChange()"
  (ionTabsDidChange)="onTabChanged()"
>
  @if (showTabs() && tabs().length) {
    <ion-tab-bar
      [hidden]="!showTabs()"
      slot="bottom"
      [translucent]="true"
      class="pt-3"
    >
      @for (tab of tabs(); track tab.route) {
        <ion-tab-button
          [tab]="tab.route"
          [class.tab-selected]="tab.isActive"
        >
          <app-dynamic
            componentName="SvgIcon"
            [props]="{
              name: tab.icon,
              size: 'var(--bottombar-icon-size)',
              gradient: tab.isActive ? 'primary' : undefined,
            }"
          />
          <span
            [class]="
              'font-sans text-xs ' +
              (tab.isActive
                ? 'font-bold text-(--bottombar-selected-color)'
                : 'font-semibold text-(--bottombar-idle-color)')
            "
          >
            {{ tab.label | translate }}
          </span>
        </ion-tab-button>
      }
    </ion-tab-bar>
  }
</ion-tabs>
